var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg99(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.1 0.1 299.8 120.125",
    width: "1000px",
    height: "401px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.867 26.309C17.721 26.309.1 35.279.1 62.345c0 21.442 11.849 34.944 39.312 34.944 32.326 0 34.398-21.294 34.398-21.294H58.147s-3.358 11.466-19.69 11.466c-13.302 0-22.869-8.986-22.869-21.58h59.861v-7.904c0-12.46-7.91-31.668-36.582-31.668zM38.32 36.41c12.662 0 21.294 7.757 21.294 19.383h-43.68c0-12.343 11.268-19.383 22.386-19.383z",
    fill: "#e53238",
    "fill-color-id": 0,
    "stroke-color-id": -1,
    "recolor-fill": "true",
    "recolor-stroke": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.438.1v83.597c0 4.745-.339 11.408-.339 11.408h14.939s.537-4.785.537-9.159c0 0 7.381 11.548 27.451 11.548 21.134 0 35.49-14.674 35.49-35.695 0-19.557-13.186-35.286-35.456-35.286-20.854 0-27.334 11.261-27.334 11.261V.1H75.438zm38.766 36.753c14.352 0 23.479 10.652 23.479 24.946 0 15.328-10.541 25.355-23.376 25.355-15.318 0-23.581-11.961-23.581-25.219 0-12.354 7.414-25.082 23.478-25.082z",
    fill: "#0064D2FF",
    "fill-color-id": 1,
    "stroke-color-id": -1,
    "recolor-fill": "true",
    "recolor-stroke": "true"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.645 26.309c-31.812 0-33.852 17.418-33.852 20.202h15.834s.83-10.169 16.926-10.169c10.459 0 18.564 4.788 18.564 13.991v3.276h-18.564c-24.645 0-37.674 7.21-37.674 21.841 0 14.398 12.038 22.232 28.307 22.232 22.172 0 29.314-12.251 29.314-12.251 0 4.873.375 9.675.375 9.675h14.076s-.545-5.952-.545-9.76V52.432c0-21.582-17.408-26.123-32.761-26.123zm17.472 37.128v4.368c0 5.697-3.516 19.861-24.212 19.861-11.333 0-16.192-5.656-16.192-12.217 0-11.935 16.363-12.012 40.404-12.012z",
    fill: "#F5AF02FF",
    "fill-color-id": 2,
    "stroke-color-id": -1,
    "recolor-fill": "true",
    "recolor-stroke": "true"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.879 29.041h17.813l25.565 51.218 25.506-51.218H299.9l-46.459 91.184h-16.927l13.406-25.419-35.041-65.765z",
    fill: "#86B817FF",
    "fill-color-id": 3,
    "stroke-color-id": -1,
    "recolor-fill": "true",
    "recolor-stroke": "true"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg99);
export default __webpack_public_path__ + "static/media/img99.95eb00bc4156c438a06ca47d1560ef1b.svg";
export { ForwardRef as ReactComponent };